import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions } from 'ducks/scenarios';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/scenariosExposure/scenarioExposureSubstanceShipment';
import { mixtureSubstancesBySubstance, needsScenarioByShipment, shipmentsByRawMaterial } from 'selectors/generic';
import { SCENARIO_EF } from 'utils/constants/coreConstants';
import { lcsInternalExposure } from 'utils/constants/lcsTypes';
import { DISTRIBUIDOR } from 'utils/constants/reach_role';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioExposure/scenariosExposure';
import { currentUser } from 'selectors/currentUser';

pdfMake.addVirtualFileSystem(pdfFonts);

const Component = props => {
  const {
    conditionsData, descriptorsById, descriptorsData, lcsById, mixtureSubstancesBySubstance,
    needsScenarioByShipment, rawMaterialsById,
    scenarios, scenarioDescriptorsData, scenarioDescriptorConditionsData, shipmentsByRawMaterial,
    shipmentsById, substanceId, suppliersById,
    unitsById, user
  } = props;
  const {
    alertError, closeParentContainerConfirm, createScenario, fetchScenarios, removeScenario,
    setScenariosManagementOpen, setScenarioInitializer, setScenariosOpen,
    setShipmentInitializer, updateScenario,
  } = props;

  const tableRef = React.useRef(null);

  const [loading, setLoading] = useState(false);

  const filteredScenarios = scenarios.filter(s =>
    s.type === SCENARIO_EF &&
    // TODO remove the below line should be "s.substance_id === substanceId" ACCESS scenarios lack substance_id
    ( s.substance_id === substanceId || substanceId === shipmentsById[s.raw_material_supplier_id].raw_material_id)  &&
    s.raw_material_supplier_id &&
    lcsInternalExposure.includes(parseInt(s.lcs_id)) &&
    (
      substanceId === shipmentsById[s.raw_material_supplier_id].raw_material_id ||
      (mixtureSubstancesBySubstance[substanceId] || [])
        .map(mix => mix.mixture_id)
        .includes(shipmentsById[s.raw_material_supplier_id].raw_material_id)
    )
  );


  /**
   * ---------------------
   Shipments information for table dropdown selection.
   Shipments of substances or substances that are in Mixs that have Shipments.
   Of The shipments mentioned above only the ones chosen are:
   needsScenario(shipment)
   */
  const shipmentsLookup = {};
  (shipmentsByRawMaterial[substanceId] || []).forEach(shipment => {
      if (needsScenarioByShipment[shipment.id]) {
        shipmentsLookup[shipment.id] =
          `[ ${shipment.code} ] - [ ${rawMaterialsById[substanceId].code} ] ${rawMaterialsById[substanceId].name} - 
       [ ${suppliersById[shipment.supplier_id].code} ] ${suppliersById[shipment.supplier_id].name} - 
       ${shipment.trade_name}`;
      }
    }
  );
  (mixtureSubstancesBySubstance[substanceId] || []).forEach(mix =>
    (shipmentsByRawMaterial[mix.mixture_id] || []).forEach(shipment => {
        if (needsScenarioByShipment[shipment.id]) {
          shipmentsLookup[shipment.id] =
            `[ ${shipment.code} ] - [ ${rawMaterialsById[mix.mixture_id].code} ] ${rawMaterialsById[mix.mixture_id].name} - 
       [ ${suppliersById[shipment.supplier_id].code} ] ${suppliersById[shipment.supplier_id].name} - 
       ${shipment.trade_name}`;
        }

      }
    )
  );
  /** --------------------- */

  const exportPDF = data => {
    pdfMake.createPdf(
      docDefinition(
        rawMaterialsById[substanceId],
        data,
        {
          conditionsData: conditionsData,
          descriptorsData: descriptorsData,
          descriptorsById: descriptorsById,
          lcsById: lcsById,
          scenarioDescriptorConditionsData: scenarioDescriptorConditionsData,
          scenarioDescriptorsData: scenarioDescriptorsData,
          shipmentsById: shipmentsById,
          suppliersById: suppliersById,
          unitsById: unitsById
        },
        'R - Cenário Substância do Fornecedor, CE DE MP - Na Produção'
      ))
      .open();
  };

  const selectScenario = rowData => {
    setScenarioInitializer(rowData);

    let augmentedShipment = {};

    if (
      (shipmentsByRawMaterial[substanceId] || [])
        .find(shipment => rowData.raw_material_supplier_id === shipment.id)
    ) {
      augmentedShipment = {
        ...(shipmentsByRawMaterial[substanceId] || [])
          .find(shipment =>  rowData.raw_material_supplier_id === shipment.id),
        shipment_substance_id: substanceId,
        shipment_id_mp: substanceId,
        raw_material_name: rawMaterialsById[substanceId].name,
        raw_material_code: rawMaterialsById[substanceId].code
      };
    } else {
      const mixIds = (mixtureSubstancesBySubstance[substanceId] || []).map(mix => mix.mixture_id);
      mixIds.forEach(id => {
        const mixShipment = (shipmentsByRawMaterial[id] || [])
          .find(shipment => rowData.raw_material_supplier_id === shipment.id);
        if (mixShipment) {
          augmentedShipment = {
            ...mixShipment,
            shipment_mixture_id: id,
            shipment_id_mp: id,
            raw_material_name: rawMaterialsById[id].name,
            raw_material_code: rawMaterialsById[id].code
          };
        }
      });
    }

    setShipmentInitializer(augmentedShipment);
    setScenariosOpen(false);
    setScenariosManagementOpen(true);
  };

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={closeParentContainerConfirm}
        title={`CE DE MP - ${rawMaterialsById[substanceId].name} - [CAS] ${rawMaterialsById[substanceId].cas} - [EC] ${rawMaterialsById[substanceId].ec}`}
        columns={columns(user, shipmentsLookup)}
        data={filteredScenarios}
        onRowClick={() => null}
        onRowDoubleClick={selectScenario}
        options={{
          actionsCellStyle: {
            minWidth: 150,
            paddingLeft: 20
          }
        }}
        isLoading={loading}
        actions={[
          {
            isFreeAction: true,
            icon: tableIcons.Pdf,
            tooltip: 'Exportar PDF',
            onClick: () => exportPDF(tableRef.current.state.data)
          },
          {
            icon: tableIcons.Pdf,
            tooltip: 'Exportar PDF',
            onClick: (event, rowData) => exportPDF([rowData])
          },
          {
            icon: tableIcons.ManageEntity,
            tooltip: 'Gerir Cenário',
            onClick: (event, rowData) => selectScenario(rowData)
          }
        ]}
        editable={{
          onRowUpdate: (newData, oldData) => {
            setLoading(true);
            return updateScenario(newData.id, newData)
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alertError(e);
              });
          },
          onRowAdd: newData => {
            setLoading(true);

            // There cannot be CE DE MP - scenarios with code repetitions
            if (scenarios.some(sef => sef.code === newData.code && sef.type === SCENARIO_EF)) {
              return Promise.reject()
                .catch(e => alertError("Não pode adicionar cenários com Códigos iguais"))
                .finally(() => setLoading(false));
            }

            return createScenario({
              substance_id: substanceId,
              raw_material_supplier_id: newData.raw_material_supplier_id,
              code: newData.code,
              designation: newData.designation,
              notes: newData.notes,
              lcs_id: newData.lcs_id,
              type: SCENARIO_EF
            })
              .then(() => fetchScenarios())
              .catch(e => alertError(e))
              .finally(() => setLoading(false));
          },
          onRowDelete: oldData => {
            setLoading(true);
            return removeScenario(oldData.id)
              .catch(e => alertError(e))
              .finally(() => setLoading(false));
          }
        }}
      />
    </Grid>
  );
};

const mapStateToProps = (state, props) => ({
  mixtureSubstancesBySubstance: mixtureSubstancesBySubstance(state),
  needsScenarioByShipment: needsScenarioByShipment(state),
  rawMaterialsById: state.rawMaterials.models,
  scenarios: state.scenarios.data,
  shipmentsByRawMaterial: shipmentsByRawMaterial(state),
  shipmentsById: state.rawMaterialSuppliers.models,
  suppliersById: state.suppliers.models,
  user: currentUser(state),
  scenarioDescriptorsData: state.scenarioDescriptors.data,
  descriptorsData: state.descriptors.data,
  descriptorsById: state.descriptors.models,
  conditionsData: state.conditions.data,
  scenarioDescriptorConditionsData: state.scenarioDescriptorConditions.data,
  unitsById: state.units.models,
  lcsById: state.descriptors.models
});

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  createScenario: data => dispatch(actions.createPromise(data)),
  fetchScenarios: () => dispatch(actions.fetchAll()),
  updateScenario: (id, data) => dispatch(actions.updatePromise(id, data)),
  removeScenario: id => dispatch(actions.removePromise(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
